export default __webpack_public_path__ + "static/media/tmb.c6a3cd3f.svg";